<template>
  <v-slide-y-reverse-transition
    mode="in-out"
    hide-on-leave>
    <v-layout 
      row 
      wrap>
      <v-flex 
        xs12> 
        <v-list
          v-if="myFriends.length > 0"
          style="max-width: 600px; margin: auto;"
          three-line
          class="transparent">
          <!-- <template v-for="(item, index) in items"> -->
            
          <template v-if="friendRequests.length > 0">
            <v-subheader>
              <!-- TODO: Text/Translate -->

              Freundschaftsanfragen
            </v-subheader>
            <template v-for="(item) in friendRequests">
              <!-- <v-divider
              :key="index"
              :inset="false">
            </v-divider> -->
            
              <v-list-tile
                :key="item.friendId"
                class="white mb-1 elevation-1"
                avatar
                :to="'/profile/' + item.uniqueId">
                <v-list-tile-avatar style="margin: auto">
                  <img :src="item.friendProfileImg">
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ item.friendName }}
                  </v-list-tile-title>
                  <span class="ml-1 caption grey--text font-italic">
                    <v-icon size="14">
                      fas fa-fingerprint
                    </v-icon> {{ item.uniqueId }}
                  </span>
                  <v-list-tile-sub-title 
                    style="overflow: hidden; white-space: nowrap;" 
                    class="caption font-italic">
                    {{ item.friendStatus }}
                  </v-list-tile-sub-title>
                  
                <!-- Next Event/Moment? -->
                <!-- <v-list-tile-sub-title 
                  style="overflow: hidden; white-space: nowrap;">
                  <v-icon 
                    small 
                    class="mr-1">
                    Icon {{ item.icon }}
                  </v-icon>Subtitle: {{ item.subtitle }}
                </v-list-tile-sub-title>
                <v-list-tile-sub-title
                  style="overflow: hidden; white-space: nowrap;">
                  Date: {{ item.date }}
                </v-list-tile-sub-title> -->
                </v-list-tile-content>
               
                <!-- Friend Requests / Status  -->
                <v-list-tile-action
                  @click.prevent="">
                  <app-buttons-friend-status
                  
                    :item="item">
                  </app-buttons-friend-status>
                </v-list-tile-action>
               
              <!-- Star-Markierung für "Best-Friends" -->
              <!-- <v-list-tile-action>
                <v-list-tile-action-text>noth</v-list-tile-action-text>
                <v-icon
                  v-if="selected.indexOf(index) < 0"
                  color="grey lighten-1"
                  @click="toggleBestFriends(index)">
                  star_border
                </v-icon>

                <v-icon
                  v-else
                  color="yellow darken-2"
                  @click="toggleBestFriends(index)">
                  star
                </v-icon>
              </v-list-tile-action> -->
              </v-list-tile>
            </template>
          </template>

          <template v-if="orderedFriends.length > 0">
            <!-- TODO: Text/Translate -->

            <v-subheader>
              <!-- TODO: Text/Translate -->

              Freunde
            </v-subheader>
            <template v-for="(item) in orderedFriends">
              <!-- <v-divider
              :key="index"
              :inset="false">
            </v-divider> -->
            
              <v-list-tile
                :key="item.friendId"
                class="white mb-1 elevation-1"
                avatar
                :to="'/profile/' + item.uniqueId">
                <v-list-tile-avatar style="margin: auto">
                  <img :src="item.friendProfileImg">
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ item.friendName }}
                  </v-list-tile-title>
                  <span class="ml-1 caption grey--text font-italic">
                    <v-icon size="14">
                      fas fa-fingerprint
                    </v-icon> {{ item.uniqueId }}
                  </span>
                 
                  <v-list-tile-sub-title 
                    style="overflow: hidden; white-space: nowrap;" 
                    class="caption font-italic">
                    {{ item.friendStatus }}
                  </v-list-tile-sub-title>

                <!-- Next Event/Moment? -->
                <!-- <v-list-tile-sub-title 
                  style="overflow: hidden; white-space: nowrap;">
                  <v-icon 
                    small 
                    class="mr-1">
                    Icon {{ item.icon }}
                  </v-icon>Subtitle: {{ item.subtitle }}
                </v-list-tile-sub-title>
                <v-list-tile-sub-title
                  style="overflow: hidden; white-space: nowrap;">
                  Date: {{ item.date }}
                </v-list-tile-sub-title> -->
                </v-list-tile-content>

                <!-- Friend Requests / Status  -->
                <v-list-tile-action
                  @click.prevent="">
                  <app-buttons-friend-status
                  
                    :item="item"
                    :user="user">
                  </app-buttons-friend-status>
                </v-list-tile-action>
              <!-- Star-Markierung für "Best-Friends" -->
              <!-- <v-list-tile-action>
                <v-list-tile-action-text>noth</v-list-tile-action-text>
                <v-icon
                  v-if="selected.indexOf(index) < 0"
                  color="grey lighten-1"
                  @click="toggleBestFriends(index)">
                  star_border
                </v-icon>

                <v-icon
                  v-else
                  color="yellow darken-2"
                  @click="toggleBestFriends(index)">
                  star
                </v-icon>
              </v-list-tile-action> -->
              </v-list-tile>
            </template>
          </template>
        </v-list>
        <v-hover v-else>
          <v-card
            slot-scope="{ hover }"
            class="mt-5 py-5 roundedcard"
            :class="`elevation-${hover ? 20 : 12}`"
            style="width: 300px; margin: auto;">
            <v-card-text class="my-5">
              <v-layout 
                row 
                wrap>
                <v-flex
                  xs12>
                  <!-- <v-flex class="text-xs-center">
              <span class="headline">
                Nix los
              </span>
            </v-flex> -->

                  <v-flex class="mt-2 text-xs-center">
                    <v-icon
                      color="secondary"
                      size="100">
                      fas fa-user-astronaut
                    </v-icon>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </v-slide-y-reverse-transition>
</template>


<script>
import { mapState } from 'vuex'
import { orderBy, filter } from 'lodash'

import ButtonsFriendRequestDisplay from '@/components/global_comps/FriendRequest/ButtonsFriendRequestDisplay.vue'


export default {
  components: {
    // eslint-disable-next-line
    "app-buttons-friend-status": ButtonsFriendRequestDisplay
  },
  data() {
    return {
      search: '',
      searchArray: [],
      
      
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
      path: state => state.route.path,
      isMobile: state => state.isMobile,
      foundFriends: state => state.friends.foundFriends,
      searchActive: state => state.searchActive,
      myFriends: state => state.user.myFriends
    }),
    
    friendRequests () {
      var requests = filter(this.myFriends, item => item.acceptedByUser === false || item.acceptedByFriend === false)
      return orderBy(requests, 'requestTime', 'desc')
    },

    orderedFriends() {
      var friends = filter(this.myFriends, item => item.acceptedByUser === true && item.acceptedByFriend === true)

      return orderBy(friends, 'name', 'asc')
    },

  },
  created() {
    console.log('myFriendsArray', this.myFriends)
    console.log('myFriendsArrayOrdered', this.orderedFriends)
    console.log('friendRequests', this.friendRequests)
  },



  methods: {
   
    

    toggleBestFriends(index) {
      const i = this.selected.indexOf(index)

      if (i > -1) {
        this.selected.splice(i, 1)
      } else {
        this.selected.push(index)
      }
    }
  }
}
</script>
